/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:ff25a4ca-9371-4f02-a49e-d9902e4e52de",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_Y01SfvGkO",
    "aws_user_pools_web_client_id": "1ftkeurtmsid3k1309cor3r3gn",
    "oauth": {}
};


export default awsmobile;
